export const twoSignificantDigits = (num: number): number =>
  Math.round(num * 100) / 100
